<ul
  app-sub-menu
  [item]="menuItens"
  [root]="true"
  [reset]="reset"
  [visible]="true"
  [parentActive]="true"
  [activeUrl]="activeUrl"
  (onMoveBar)="moveBar.emit()"
  class="ultima-menu ultima-main-menu clearfix"
></ul>
